import React from 'react'

import {
  EuiTitle,
  EuiSpacer,
  EuiFlexGroup,
  EuiFlexItem,
  EuiHorizontalRule,
} from '@elastic/eui'

import IntroCards from './IntroOutdoorManualToC'

export default function IntroHome() {

  return (
    <React.Fragment>
      <EuiSpacer />
        <EuiTitle size="m">
            <h2>INSTAR IP Aussenkameras - Handbücher</h2>
        </EuiTitle>
        <EuiTitle size="s">
            <h4>Outdoor Überwachungskamera mit Full HD, PIR-Sensor und Weitwinkelobjektiv. Robustes Gehäuse und wetterfeste Kabel für den flexiblen Einsatz.</h4>
        </EuiTitle>
        <EuiHorizontalRule margin="xs" />
      <EuiFlexGroup gutterSize="l" direction="column" style={{margin: '0 7px'}} >
        <EuiFlexItem>
          <IntroCards />
        </EuiFlexItem>
    </EuiFlexGroup>
  </React.Fragment>
  );
}